import moment from 'moment';
import isUndefined from 'lodash/isUndefined';
import isString from 'lodash/isString';
import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import vCardsJS from './lib';

export default {
  convertFromOutlook(one) {
    // create a new vCard
    const vCard = vCardsJS();

    // set basic properties shown before
    vCard.firstName = one['First Name'];
    vCard.middleName = one['Middle Name'];
    vCard.lastName = one['Last Name'];
    // vCard.uid = '69531f4a-c34d-4a1e-8922-bd38a9476a53';
    vCard.organization = one.Company;

    // link to image
    // vCard.photo.attachFromUrl('https://avatars2.githubusercontent.com/u/5659221?v=3&s=460', 'JPEG');

    // or embed image
    // vCard.photo.attachFromUrl('/path/to/file.jpeg');

    vCard.workPhone = [
      one['Company Main Phone'],
      one['Business Phone'],
      one['Business Phone 2'],
    ];
    vCard.birthday = one.Birthday ? moment(one.Birthday).toDate() : '';
    vCard.title = one['Job Title'];
    vCard.url = one['Web Page'] || one['Personal Web Page'];
    // vCard.workUrl = 'https://acme-corporation/enesser';
    vCard.note = one.Notes;

    // set other vitals
    vCard.nickname = one.Nickname;
    vCard.namePrefix = one.Title;
    vCard.nameSuffix = one.Suffix;
    vCard.gender = one.Gender;
    vCard.anniversary = one.Anniversery ? moment(one.Anniversery).toDate() : '';
    vCard.role = one['Job Title'];

    // set other phone numbers
    vCard.homePhone = [
      one['Primary Phone'],
      one['Home Phone'],
      one['Home Phone 2'],
    ];
    vCard.cellPhone = one['Mobile Phone'];
    vCard.otherPhone = [
      one['Other Phone'],
      one['Car Phone'],
      one['Radio Phone'],
      one['TTY/TDD Phone'],
    ];
    vCard.pagerPhone = one.Pager;

    // set fax/facsimile numbers
    vCard.homeFax = one['Home Fax'];
    vCard.workFax = one['Business Fax'];

    // set email addresses
    vCard.email = [
      one['E-mail Address'],
      one['E-mail 2 Address'],
      one['E-mail 3 Address'],
    ];
    // vCard.workEmail = [];

    // set logo of organization or personal logo (also supports embedding, see above)
    // vCard.logo.attachFromUrl('https://avatars2.githubusercontent.com/u/5659221?v=3&s=460', 'JPEG');

    // set URL where the vCard can be found
    // vCard.source = 'http://mywebpage/myvcard.vcf';

    // set address information
    // vCard.homeAddress.label = 'Home Address';
    vCard.homeAddress.street = `
      ${one['Home Street'] || ''} ${one['Home Street 2'] || ''} ${one['Home Street 3'] || ''}
    `.trim();
    vCard.homeAddress.city = one['Home City'];
    vCard.homeAddress.stateProvince = one['Home State'];
    vCard.homeAddress.postalCode = one['Home Postal Code'];
    vCard.homeAddress.countryRegion = one['Home Country/Region'] || one['Home Country'];

    // vCard.workAddress.label = 'Work Address';
    vCard.workAddress.street = `
      ${one['Business Street'] || ''} ${one['Business Street 2'] || ''} ${one['Business Street 3'] || ''}
    `.trim();
    vCard.workAddress.city = one['Business City'];
    vCard.workAddress.stateProvince = one['Business State'];
    vCard.workAddress.postalCode = one['Business Postal Code'];
    vCard.workAddress.countryRegion = one['Business Country/Region'] || one['Business Country'];

    // set social media URLs
    // vCard.socialUrls['facebook'] = 'https://...';
    // vCard.socialUrls['linkedIn'] = 'https://...';
    // vCard.socialUrls['twitter'] = 'https://...';
    // vCard.socialUrls['flickr'] = 'https://...';
    // vCard.socialUrls['custom'] = 'https://...';

    // you can also embed photos from files instead of attaching via URL
    // vCard.photo.embedFromFile('photo.jpg');
    // vCard.logo.embedFromFile('logo.jpg');

    // can also support 2.1 and 4.0, certain versions only support certain fields
    vCard.version = '3.0';

    // save to file
    // vCard.saveToFile('./eric-nesser.vcf');

    this.clean(vCard);
    // console.log(vCard.getFormattedString(), '\r\n');

    // get as formatted string
    return vCard.getFormattedString();
  },

  convertFromGmail(one) {
    // create a new vCard
    const vCard = vCardsJS();

    // set basic properties shown before
    vCard.firstName = one['Given Name'];
    vCard.middleName = one['Additional Name'];
    vCard.lastName = one['Family Name'];
    // vCard.uid = '69531f4a-c34d-4a1e-8922-bd38a9476a53';
    vCard.organization = (
      one['Organization 1 - Name']
      || one['Organization 2 - Name']
      || one['Organization 3 - Name']
      || one['Organization 4 - Name']
    );

    // link to image
    vCard.photo.attachFromUrl(one.Photo);
    // vCard.photo.attachFromUrl('https://avatars2.githubusercontent.com/u/5659221?v=3&s=460', 'JPEG');

    // or embed image
    // vCard.photo.attachFromUrl('/path/to/file.jpeg');

    vCard.workPhone = [
      one['Phone 1 - Value'],
      one['Phone 2 - Value'],
      one['Phone 3 - Value'],
      one['Phone 4 - Value'],
    ];
    vCard.birthday = one.Birthday ? moment(one.Birthday).toDate() : '';
    vCard.title = (
      one['Organization 1 - Title']
      || one['Organization 2 - Title']
      || one['Organization 3 - Title']
      || one['Organization 4 - Title']
    );
    vCard.url = (
      one['Website 1 - Value']
      || one['Website 2 - Value']
      || one['Website 3 - Value']
      || one['Website 4 - Value']
    );
    // vCard.workUrl = 'https://acme-corporation/enesser';
    vCard.note = one.Notes;

    // set other vitals
    vCard.nickname = one.Nickname;
    vCard.namePrefix = one['Name Prefix'];
    vCard.nameSuffix = one['Name Suffix'];
    vCard.gender = one.Gender;
    vCard.anniversary = one.Anniversery ? moment(one.Anniversery).toDate() : '';
    vCard.role = (
      one['Organization 1 - Title']
      || one['Organization 2 - Title']
      || one['Organization 3 - Title']
      || one['Organization 4 - Title']
    );

    // set other phone numbers
    vCard.homePhone = [];
    // vCard.cellPhone = one['Mobile Phone'];
    vCard.otherPhone = [];
    // vCard.pagerPhone = one.Pager;

    // set fax/facsimile numbers
    // vCard.homeFax = one['Home Fax'];
    // vCard.workFax = one['Business Fax'];

    // set email addresses
    vCard.email = [
      one['E-mail 1 - Value'],
      one['E-mail 2 - Value'],
      one['E-mail 3 - Value'],
      one['E-mail 4 - Value'],
    ];
    // vCard.workEmail = [];

    // set logo of organization or personal logo (also supports embedding, see above)
    // vCard.logo.attachFromUrl('https://avatars2.githubusercontent.com/u/5659221?v=3&s=460', 'JPEG');

    // set URL where the vCard can be found
    // vCard.source = 'http://mywebpage/myvcard.vcf';

    // set address information
    vCard.homeAddress.label = (
      one['Address 1 - Street']
      || one['Address 2 - Street']
      || one['Address 3 - Street']
      || one['Address 4 - Street']
    );
    vCard.homeAddress.street = (
      one['Address 1 - Street']
      || one['Address 2 - Street']
      || one['Address 3 - Street']
      || one['Address 4 - Street']
    );
    vCard.homeAddress.city = (
      one['Address 1 - City']
      || one['Address 2 - City']
      || one['Address 3 - City']
      || one['Address 4 - City']
    );
    vCard.homeAddress.stateProvince = (
      one['Address 1 - Region']
      || one['Address 2 - Region']
      || one['Address 3 - Region']
      || one['Address 4 - Region']
    );
    vCard.homeAddress.postalCode = (
      one['Address 1 - Postal Code']
      || one['Address 2 - Postal Code']
      || one['Address 3 - Postal Code']
      || one['Address 4 - Postal Code']
    );
    vCard.homeAddress.countryRegion = (
      one['Address 1 - Country']
      || one['Address 2 - Country']
      || one['Address 3 - Country']
      || one['Address 4 - Country']
    );

    // vCard.workAddress.label = 'Work Address';
    // vCard.workAddress.street = `
    //   ${one['Business Street'] || ''} ${one['Business Street 2'] || ''} ${one['Business Street 3'] || ''}
    // `.trim();
    // vCard.workAddress.city = one['Business City'];
    // vCard.workAddress.stateProvince = one['Business State'];
    // vCard.workAddress.postalCode = one['Business Postal Code'];
    // vCard.workAddress.countryRegion = one['Business Country/Region'] || one['Business Country'];

    // set social media URLs
    // vCard.socialUrls['facebook'] = 'https://...';
    // vCard.socialUrls['linkedIn'] = 'https://...';
    // vCard.socialUrls['twitter'] = 'https://...';
    // vCard.socialUrls['flickr'] = 'https://...';
    // vCard.socialUrls['custom'] = 'https://...';

    // you can also embed photos from files instead of attaching via URL
    // vCard.photo.embedFromFile('photo.jpg');
    // vCard.logo.embedFromFile('logo.jpg');

    // can also support 2.1 and 4.0, certain versions only support certain fields
    vCard.version = '3.0';

    // save to file
    // vCard.saveToFile('./eric-nesser.vcf');

    this.clean(vCard);
    // console.log(vCard.getFormattedString(), '\r\n');

    // get as formatted string
    return vCard.getFormattedString();
  },

  clean(obj) {
    const card = obj;

    Object.keys(card)
      .forEach((key) => {
        if (isUndefined(card[key])) {
          card[key] = '';
        }

        if (isArray(card[key])) {
          card[key] = card[key].filter((value) => (
            !isUndefined(value) || (isString(value) && value.trim() !== '')
          ));
        }

        if (isPlainObject(card[key])) {
          this.clean(card[key]);
        }
      });
  },
};
